import { useState, useMemo, useEffect, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { getContentId } from '@tabeeb/modules/shared/content/selectors'

import { ListItemIcon, MenuItem } from '@mui/material'
import { AlarmOutlined } from '@mui/icons-material'
import ReminderManager from '../ReminderManager'

import { getAvailableReminderReceivers, setExistingReminder, setNewReminder } from '../../actions'
import { getExistingReminders, getIsReminderIconVisible } from '../../selectors'

import { getDefaultReminderSettings } from '../../services/defaultReminderSettings'

const Reminder = ({ type, entity }) => {
  const dispatch = useDispatch()

  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState(false)
  const prevIsSettingsDialogOpenRef = useRef(isSettingsDialogOpen)

  const reminders = useSelector((state) => getExistingReminders(state, { type, entity }))
  const isVisible = useSelector(getIsReminderIconVisible)
  const contentId = useSelector(getContentId)

  const defaultReminder = useMemo(() => getDefaultReminderSettings(type, entity), [type, entity])

  useEffect(() => {
    if (isSettingsDialogOpen) {
      dispatch(getAvailableReminderReceivers.request({ contentId, formId: entity.FormId }))
    } else if (prevIsSettingsDialogOpenRef.current) {
      dispatch(getAvailableReminderReceivers.resetState())
    }
  }, [dispatch, contentId, entity.FormId, isSettingsDialogOpen])

  const _handleDialogOpen = useCallback(() => {
    dispatch(setNewReminder(defaultReminder))
    setIsSettingsDialogOpen(true)
    prevIsSettingsDialogOpenRef.current = false
  }, [defaultReminder, dispatch])

  const _handleDialogClose = useCallback(() => {
    dispatch(setNewReminder(null))
    dispatch(setExistingReminder(null))
    setIsSettingsDialogOpen(false)
    prevIsSettingsDialogOpenRef.current = true
  }, [dispatch])

  if (!isVisible) {
    return null
  }

  return (
    <>
      <MenuItem onClick={_handleDialogOpen}>
        <ListItemIcon>
          <AlarmOutlined color={reminders.length > 0 ? 'success' : undefined} />
        </ListItemIcon>
        Set reminder
      </MenuItem>
      {isSettingsDialogOpen && (
        <ReminderManager
          onCloseDialog={_handleDialogClose}
          isOpen={isSettingsDialogOpen}
          reminders={reminders}
          defaultReminder={defaultReminder}
        />
      )}
    </>
  )
}

Reminder.propTypes = {
  type: PropTypes.number.isRequired,
  entity: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    FormId: PropTypes.number.isRequired,
  }),
}

export default Reminder
